import * as React from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import usePageLoaded from '../../hooks/usePageLoaded'
import { useShowBackButton } from '../../hooks/useBackButton'

import PageHeader from '../../components/profile/pageHeader'
import ContributionsList from '../../components/profile/materials/contributionsList'
import SomethingError from '../../components/somethingError/somethingError'
import PaginationWrapper from '../../components/pagination/paginationWrapper'

import { RootState } from '../../store/rootReducer'
import { ContributionType } from './../../store/contributions/contributionsTypings'
import { Helmet } from 'react-helmet'
import { META } from '../../constants/meta'
import { getLangFromPath, getPrefixFromPath } from '../../i18next'

import { fetchContributionsInProfile, fetchProfile } from '../../store/profile/profileSlice'
import { checkAuth, loadMemberContributions, loadMemberProfile } from '../../utils/auth'
import { fetchMemberContributions } from '../../store/member/memberSlice'
import paths from '../../paths'
import { addLocationToString } from '../../utils/meta'

const ProfileContributions = () => {
    usePageLoaded()
    useShowBackButton()

    const location = useLocation()
    const dispatch = useDispatch()
    const [t] = useTranslation()

    const self = location.pathname.includes('/membre')
    const { contributionsList, user, contributionsTotal } = useSelector((state: RootState) =>
        self ? state.member : state.profile
    )

    const [currentPage, setCurrentPage] = useState(1)

    return (
        <div className="pageContent" style={{ margin: '0 auto', maxWidth: '1360px', padding: '90px 27px' }}>
            {user ? (
                <>
                    <Helmet>
                        <title>
                            {self
                                ? META.myContributions[getLangFromPath(location.pathname)].title
                                : addLocationToString(
                                      META.userContributions[getLangFromPath(location.pathname)].title.replace(
                                          '{NICK}',
                                          user.nick
                                      ),
                                      user
                                  )}
                        </title>
                        <meta
                            name="description"
                            content={
                                self
                                    ? META.myContributions[getLangFromPath(location.pathname)].description
                                    : addLocationToString(
                                          META.userContributions[
                                              getLangFromPath(location.pathname)
                                          ].description.replace('{NICK}', user.nick),
                                          user
                                      )
                            }
                        />
                    </Helmet>
                    <div className="pageRow">
                        <PageHeader text={t('My contributions')} user={user} self={self} />
                    </div>
                    <ContributionsList contributions={contributionsList} contributionsTotal={contributionsTotal} />
                    <PaginationWrapper
                        limit={20}
                        limitOptions={5}
                        maxButtons={5}
                        activePage={currentPage}
                        onchange={(page) => {
                            setCurrentPage(page)
                            dispatch(
                                self
                                    ? fetchMemberContributions({ user_id: user.id, p: page })
                                    : fetchContributionsInProfile({ user_id: user.id, p: page })
                            )
                        }}
                        total={contributionsTotal}
                    />
                </>
            ) : (
                <SomethingError />
            )}
        </div>
    )
}

// @ts-ignore
ProfileContributions.getInitialProps = async ({ req, store, match }) => {
    const self = match.path.includes('/membre')

    if (self) {
        await checkAuth(store, true)
        const {
            member: { loggedIn }
        } = store.getState()

        if (loggedIn) {
            // await loadMemberProfile(store)
            await loadMemberContributions(store)
        } else {
            if (!loggedIn)
                return {
                    redirectTo: `${getPrefixFromPath(req.url)}/login_required?returnPath=${paths.myContributions.path}`
                }
        }
    } else {
        const {
            params: { nick }
        } = match
        await store.dispatch(fetchProfile({ nick }))
        const {
            profile: { user }
        } = store.getState()

        if (!user) return { statusCode: 404 }

        await store.dispatch(fetchContributionsInProfile({ user_id: user.id, p: 1 }))
    }
}

export default ProfileContributions
